module.exports = __webpack_public_path__ + "static/img/asstCommLabor.6e6a4e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/asstCommLabor.jpg
// module id = KJeY
// module chunks = 0